import myUpload from './myUpload'

const upload = {
  install(Vue) {
    Vue.component(myUpload.name, myUpload)
  }
}

export default upload
